import engine from "store/src/store-engine";
import localStorage from "store/storages/localStorage";
import sessionStorage from "store/storages/sessionStorage";
import memoryStorage from "store/storages/memoryStorage";

export const store = engine.createStore([localStorage, sessionStorage, memoryStorage], []);
